import styled from '@emotion/styled'

import Image from '@segment/matcha/components/Image'

import engageCustomersPng2x from './assets/EngageCustomers@2x.png'
import engageCustomersWebp from './assets/EngageCustomers.webp'
import engageCustomersWebp2x from './assets/EngageCustomers@2x.webp'

const SIZES = `557px, 1114px`

const EngageCustomersImage = () => {
  return (
    <ImageWrapper>
      <picture>
        <source
          type="image/webp"
          srcSet={`${engageCustomersWebp} 557w, ${engageCustomersWebp2x} 1114w`}
          sizes={SIZES}
        />
        <Image
          src={engageCustomersPng2x}
          sizes={SIZES}
          alt="Build Complete View"
          width="557"
          height="462"
          loading="lazy"
        />
      </picture>
    </ImageWrapper>
  )
}

const ImageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0px;

  ${({ theme }) => theme.breakpoints.up(`md`)} {
    height: 100%;
  }
`

export default EngageCustomersImage
